import React, { useState } from 'react';
import { Button, Card, Divider, Form, Input, Modal } from 'antd';
import { LockKeyhole, LockKeyholeOpen } from 'lucide-react';
import { lockScreenActions } from '../../service/api';
import { useDispatch, useSelector } from 'react-redux';
import { getDashboard } from '../../feature/staffs/dashboard/DashboardSlice';

const VerifyLock = () => {
    const [otp, setOtp] = useState("");
    const [isLoading, setIsLoading] = useState(false)
    const [form] = Form.useForm()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { dashboardData } = useSelector((state) => state.dashboards);
    const { isLock } = dashboardData;
    const dispatch=useDispatch()

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onFinish = async () => {
        setIsLoading(true);
        try {
            const res = await lockScreenActions({ pin: otp });
            if (res.status === 201) {
                setOtp(null)
                form.resetFields()
                handleCancel()
                dispatch(getDashboard())
            }

        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }
    }

    const onFinishFeild = (value) => {
        message.error("PIN  is required !")
        console.log(value)
    }
    return (
        <>
            <Button icon={isLock ? <LockKeyhole size={20} /> : <LockKeyholeOpen />} shape="circle" onClick={showModal}></Button>

            <Modal
                title="Verify Your Pin"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={false}
                width={400}
            >
                <Divider dashed style={{marginBottom:"0"}} />

                <Card>

                    <Form
                        form={form}
                        name="normal_login"
                        onFinish={onFinish}
                        onFinishFailed={onFinishFeild}
                        layout="vertical"
                    >

                        <Form.Item
                            name="pin"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter your pin "
                                },
                                {
                                    pattern: /^[0-9]+$/,
                                    message: "Only numbers are allowed!",
                                },
                            ]}
                        >
                            <center>
                                <Input.OTP length={4} onChange={(value) => {
                                    setOtp(value);
                                    form.setFieldsValue({ pin: value });
                                }} />
                            </center>
                        </Form.Item>
                        <Form.Item >
                            <Button type='primary' size="large" block="true" loading={isLoading} htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Modal>
        </>
    );
};
export default VerifyLock;